/* eslint-disable max-len */
import { FunctionComponent as F } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Subtitle from '../../components/UI/Text/Subtitle';
import ArticleText from '../../components/UI/Text/ArticleText';
import Container from '@mui/material/Container';
import { FUNDRAISERS } from '../../core/router/paths';
import Link from '@mui/material/Link';


const Plans: F = () =>
{
  return (
    <Container>
      <Stack spacing={2}>

        <ArticleText>
          Here I outline some exciting plans. Since this is far from a promise of future features, I am cautious to share too much, but if there is interest then we could begin brainstorming ideas 💭. I also wish to be transparent with my intentions for monetizing Protoplan.
        </ArticleText>

        <Subtitle>Release date 📅</Subtitle>
        <ArticleText>
          Currently Protoplan is available to use, but service is far from consistent as bugs easily creep in during active development. This is far from the level of reliability I would like – using buggy software is more than frustrating. So, I plan to mark an official release date in the calendar when I have confidence that Protoplan is stable in its basic functions.
          <br/><br/>
          I also plan to systematically gather some user feedback to optimise the UI, and gather a group of users to do some manual testing.
        </ArticleText>

        <Subtitle>Protoplan Premium 🌟</Subtitle>
        <ArticleText>
          I want Protoplan to be a gift to the community and a helping hand to those in most need. This is why I plan to keep all features available at release, free. The need for supplement budgeting is highest amongst those with limited funds, and are the people I want to empower with this tool.
          <br/><br/>
          I also plan to release a Premium version for a small monthly subscription fee, with several exclusive features. One I have trialled already is an email reminder feature to notify you when you may need to reorder supplements so you can more easily keep on top of your supplies. I hope to share more once work has begun.
        </ArticleText>

        <Subtitle>Other ways you can support Protoplan 🥰</Subtitle>

        <ArticleText>
          You can donate <Link underline='none' target='_blank' rel='noreferrer noopener' href='https://www.paypal.com/donate/?business=9B653LR2MPBPS&no_recurring=0&item_name=for+server+fees+and+WBBJ+%F0%9F%8D%B7%F0%9F%A5%B0%F0%9F%98%84&currency_code=GBP'>here</Link> to support Protoplan’s current running costs (the server fee) and my future work - thank you! 🙏

          <br/><br/>
          Sharing the existence of Protoplan and interacting on the Instagram account will help bring Protoplan to more people who may benefit.
          <br/><br/>
          I am heartened by the recent outpouring of financial support for those in need. If it feels right to you, consider donating to one of
          <Link underline='none' component={RouterLink} to={FUNDRAISERS}> these causes</Link>.
        </ArticleText>

        <Subtitle>Future projects</Subtitle>
        <ArticleText>
          Sometime after Protoplan’s release, I hope to start work on a second project. I have an idea I am eager to work on, but am also open to suggestions. To me there is no greater purpose I can fulfill than to serve this community - I’m sure many of you feel the same way.
          <br/><br/>
          If there is no other project underway, I would like to create a platform hosting an index for Medical Medium® information.
          This would take the form of detailed links and references (think timestamps and page numbers) to Medical Medium® resources across his various platforms, categorised by topic. This would rely on contribution of these references by the community and eventually provide a near-comprehensive guide to the most helpful resources to consult for any given topic - anything from shingles, to fireworks 🎆.
          In this way we can make finding the information we’re looking for easier than ever. There would also be an opportunity for links to helpful resources from various practitioners.
          I would love to hear your thoughts, ideas and feedback on this concept 🗨
          <br/><br/>
          Alternatively, it would be a lot of fun to create some kind of social platform. For instance, I have seen requests floating about for a dating app! 💕
        </ArticleText>

        <br/><br/>
      </Stack>


    </Container>

  );
};

export default Plans;
